import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import { CreatorScreen as BaseCreatorScreen } from '@configuratorware/configurator-frontendgui/App/Modules/Creator/CreatorScreen';
import BaseOption from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Components/Option';
import CustomOptionsListContainer from '../Containers/OptionsList/OptionsList';
import CustomProductPartsListContainer from '../Containers/ProductsPartList/ProductsPartList';
import IncompatibilityAlert from '../Components/IncompatibilityAlert/IncompatibilityAlert';

import ThemeProvider from '../Custom/ThemeProvider';
import { renderVisualization } from '../Components/SplitVisualizationContainer/SplitVisualizationContainer';
import { CustomVisualizationProvider } from './CustomVisualizationProvider';
import CustomAmountPriceContainer from '../Containers/AmountPrice/AmountPrice';

const AmountPriceContainer = (props) => <CustomAmountPriceContainer {...props} />;

const OptionsListContainer = (props) => (
  <CustomOptionsListContainer {...props} OptionComponent={BaseOption} />
);
const ProductsPartContainer = (dispatchAction, onOptionClassificationSelect, selectOptionClassification) => (
  <CustomProductPartsListContainer
    onSelect={(optionClassification) => {
      onOptionClassificationSelect(dispatchAction, optionClassification, selectOptionClassification);
    }}
  />
);

const CreatorScreen = (props) => (
  <BaseCreatorScreen
    {...props}
    OptionsListContainer={OptionsListContainer}
    renderProductParts={ProductsPartContainer}
    renderAmountPrice={AmountPriceContainer}
  />
);

const ConfiguratorScreen = (props) => (
  <ConnectedConfiguratorScreen
    {...props}
    CreatorScreen={CreatorScreen}
    customElements={{
      root: <IncompatibilityAlert />,
    }}
    renderVisualization={renderVisualization}
    ThemeProvider={ThemeProvider}
    VisualizationProvider={CustomVisualizationProvider}
  />
);

export default ConfiguratorScreen;
